/**
 * Las ideas de arranque del prompt, según el negocio de la bienvenida.
 *
 * Sin respuesta (o con «Otro») salen las de siempre, una por tipo de negocio
 * (`PROMPT_TEMPLATES`). Con ella, esa fila ya no tiene sentido —el tipo de
 * negocio ya lo dijo—, así que enseña tres ideas concretas de SU industria:
 * a un restaurante, una taquería, un café o un restaurante para eventos.
 *
 * No son estilos a propósito: el color, la letra y el estilo se eligen después,
 * en sus pasos del asistente. Aquí va de qué es el sitio. Al pulsar una se
 * escribe entera en el campo y se puede editar, como las de siempre.
 */
import type { WelcomeBusiness } from './welcomeAnswers'

/** Cuántas ideas tiene cada industria en el catálogo (`start.idea.<negocio>.<n>`). */
const IDEAS_PER_BUSINESS = 3

export type PromptIdea = { label: string; prompt: string }

/** Las ideas de esa industria, o `null` para usar las de siempre. */
export function industryIdeas(business: WelcomeBusiness | null | undefined): PromptIdea[] | null {
  if (!business || business === 'other') return null
  return Array.from({ length: IDEAS_PER_BUSINESS }, (_, index) => ({
    label: `start.idea.${business}.${index + 1}`,
    prompt: `start.idea.${business}.${index + 1}.prompt`,
  }))
}
